import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "./apiService.ts";

const getAtual = async () => {
  const result = await handleService({ endpoint: "/empresa/atual" });
  return result;
};

// CNPJ não faz parte do payload de propósito — é travado no backend
// (identidade fiscal ligada ao customer do ASAAS), não é alterável por aqui.
const alterar = async (dados: {
  nome?: string;
  email?: string;
  fantasia?: string;
  logradouro?: string;
  numero?: string;
  municipio?: string;
  bairro?: string;
  uf?: string;
  cep?: string;
  // Só o usuário com perfil "Admin" (quem cadastrou a empresa) consegue gravar
  // este campo — o backend recusa para os demais.
  maxInstrumentadores?: number;

  // Mesma restrição: só o responsável pela conta grava. Desligar não apaga o
  // que já foi registrado — só interrompe novos registros.
  logAtividadeAtivo?: boolean;
}) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: "/empresa/alterar",
    data: dados,
  });
  return result;
};

const empresaService = { getAtual, alterar };

export default empresaService;
